<template>
    <div>
        <v-btn
            v-if="!noButton"
            :color="buttonColor"
            :round="buttonRound"
            :large="buttonLarge"
            @click="onPay"
            :loading="loading"
        >{{ 'Pay' | translation }}</v-btn>
    </div>
</template>

<script>
import Vue from 'vue';
import { CashPaymentType } from './config';
import gql from 'graphql-tag';
import {mapMutations} from 'vuex';

const moduleName = 'CashPaymentType';

export default {
    name: moduleName,
    props: {
        noButton: Boolean,
        buttonLarge: Boolean,
        buttonRound: Boolean,
        buttonColor: {
            type: String,
            default: 'primary'
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        ...mapMutations('Payment', [
            'setError',
        ]),
        onPay() {
            this.loading = true;
            this.$order.getOrder().then(order => {
                if (order && order.id) {
                    Vue.$graphql
                        .mutate({
                            mutation: gql`
                                mutation cashExecutePayment($orderId: Int!, $transactionId: String!) {
                                    cashExecutePayment(orderId: $orderId, transactionId: $transactionId) {
                                        success
                                    }
                                }
                            `,
                            variables: {
                                orderId: parseInt(order.id),
                                transactionId: order.transaction_id,
                            },
                        })
                        .then(() => {
                            this.$router.replace({
                                ...this.$route,
                                query: {},
                            });

                            this.$emit('success', order);
                        })
                        .catch(e => {
                            this.loading = false;
                        });
                } else {
                    this.loading = false;

                    this.setError('Order not created, please try again later.');
                }
            });
        },
    },
    install(Vue) {
        Vue.component(moduleName, this);
        Vue.$store.commit('Payment/addPaymentType', new CashPaymentType());
    },
};
</script>
